
export default {
  props: { curso: String },
  data() {
    return {
      items: [
        {
          icone: 'icone-informatica.png',
          titulo: 'Sistema Interativo',
          texto:
            'Prepare-se para mergulhar em um novo mundo de aprendizado interativo! Nossos cursos oferecem um sistema interativo de ensino que permite que você aprenda de maneira dinâmica e envolvente. Com atividades práticas, jogos educativos e uma equipe de professores apaixonados, você nunca mais vai querer aprender de outra forma. Você estará sempre envolvido em um ambiente estimulante, onde poderá compartilhar suas ideias e aprender com outros alunos e com os recursos exclusivos da Technos.',
        },
        {
          icone: 'icone-mentores.png',
          titulo: 'Mentores Preparados',
          texto:
            'Você quer ter mentores que possam ajudá-lo a alcançar seus objetivos de carreira? Nossos mentores são cuidadosamente selecionados e treinados para oferecer o suporte necessário para que você atinja seus objetivos. Além de ajudá-lo a adquirir conhecimentos e habilidades práticas, eles fornecerão orientação para que você possa crescer pessoalmente e profissionalmente. Com a experiência e a dedicação de nossos mentores, você terá a chance de se tornar um profissional de sucesso.',
        },
        {
          icone: 'icone-projetos.png',
          titulo: 'Projetos Práticos',
          texto:
            'Está pronto para aplicar seus conhecimentos em projetos práticos? Nossos cursos são projetados para ajudá-lo a desenvolver habilidades práticas por meio de projetos reais. Você terá a oportunidade de trabalhar em projetos emocionantes que lhe permitirão aplicar o que aprendeu em um ambiente do mundo real. Com a ajuda de nossos professores e mentores, você terá a oportunidade de trabalhar em projetos desafiadores e se preparar para o sucesso em sua carreira.',
        },
      ],
    }
  },
}
